export default __webpack_public_path__ + "static/media/person-5-safari-14.fb541df9.png";